import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { useAuthContext } from "../../../hooks/Auth";
import { useJobContext } from "../../../hooks/Jobs";

interface Props {
  handleClick: () => void;
  Icon: () => JSX.Element;
  text: string;
}

const SidebarItem: FC<Props> = ({ handleClick, Icon, text }) => {
  const { isUserCreditLimit } = useAuthContext();
  const { isProcessing, isMisProyectosLoading } = useJobContext();

  return (
    <ListItem disablePadding>
      <Tooltip
        title={text}
        placement="right" arrow
        componentsProps={{
          tooltip: {
              sx: {
                  backgroundColor: '#1D3D4D',
                  color: '#FFF',
                  fontFamily: 'Montserrat',
                  fontSize: '0.875rem',
                  padding: '8px 12px',
                  borderRadius: '8px',
              },
          },
          arrow: {
              sx: {
                  color: '#1D3D4D', // Color de la flecha
              },
          },
      }}>
        <ListItemButton
          disabled={
            (isUserCreditLimit && text !== "Inicio") ||
            (text === "UmmIAPlan" && isProcessing) ||
            (text === "Mis recursos de aprendizaje" && isMisProyectosLoading)
          }
          onClick={handleClick}
          sx={{
            minHeight: 48,
            justifyContent: "initial",
            px: 1.5,
            m: 0.5,
            borderTop: 0,
            color: "black",
            height: "20%",
            "&:hover": {
              backgroundColor: "rgba(249, 186, 50, 0.5)",
              borderRadius: 2,              
              transform: "scale(1.1)",
              transition: "transform 0.10s ease",
            },
            "&:hover .MuiTypography-root": {
              fontWeight: "bold",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: "auto",
              justifyContent: "center",
              color: "#336B87",
            }}
          >
            <Icon />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                ml: 3,
                fontFamily: "Montserrat",
                fontSize: "16px",
                color: "#336B87",
              }}
            >
              {text}
            </Typography>
          </ListItemText>
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};

export default SidebarItem;
